import axios from 'axios';
import { ID_NEW_CMS } from '@/helpers/constants';

const API_URL = process.env.VUE_APP_API_URL;

export default new (class {
	async getAll(facilityId) {
		const response = await axios.get(
			`${API_URL}/api/Cms/LifestyleQuestions?facilityId=${facilityId}`,
			{
				withCredentials: true,
				headers: {
					'Cache-control': 'no-cache'
				}
			}
		);
		return response.data;
	}
	async getById(lifestyle_Question_ID = ID_NEW_CMS) {
		const response = await axios.get(
			`${API_URL}/api/Cms/LifestyleQuestion?id=${lifestyle_Question_ID}`,
			{
				withCredentials: true,
				headers: {
					'Cache-control': 'no-cache'
				}
			}
		);
		return response.data;
	}
	async update(lifestyleQuestionData) {
		try {
			await axios.put(
				`${API_URL}/api/Cms/LifestyleQuestion`,
				lifestyleQuestionData,
				{
					withCredentials: true,
					headers: {
						'Cache-control': 'no-cache'
					}
				}
			);
		} catch (error) {
			console.error('Error updating lifestyle question:', error);
			throw error;
		}
	}
	async deleteById(lifestyle_Question_ID) {
		try {
			await axios.delete(
				`${API_URL}/api/Cms/LifestyleQuestion?id=${lifestyle_Question_ID}`,
				{
					withCredentials: true,
					headers: {
						'Cache-control': 'no-cache'
					}
				}
			);
		} catch (error) {
			console.error('Error deleting by ID:', error);
			throw error;
		}
	}
})();
